// Literals are as discovered in WN-LMF-1.3.dtd.
//
// Note: types.ts is not necessarily lists all of these

export const PartsOfSpeech: Record<string, string> = {
  n: "Noun",
  v: "Verb",
  a: "Adjective",
  r: "Adverb",
  s: "Adjective Satellite",
  t: "?",
  c: "Conjunction",
  p: "Adposition (Preposition, postposition, etc.)",
  x: "Other (inc. particle, classifier, bound morphemes, determiners)",
  u: "Unknown",
};

export const SenseRelationRelType: Record<string, string> = {
  also: "See also",
  anto_converse: "Converse antonym",
  anto_gradable: "Gradable antonym",
  anto_simple: "Simple antonym",
  antonym: "Antonym",
  augmentative: "Augmentative",
  derivation: "Derivation",
  diminutive: "Diminutive",
  domain_region: "Domain region",
  domain_topic: "Domain topic",
  exemplifies: "Exemplifies",
  feminine: "Feminine",
  has_augmentative: "Has augmentative",
  has_diminutive: "Has diminutive",
  has_domain_region: "Has domain region",
  has_domain_topic: "Has domain topic",
  has_feminine: "Has feminine",
  has_masculine: "Has masculine",
  has_young: "Has young",
  is_exemplified_by: "Is exemplified by",
  masculine: "Masculine",
  other: "Other",
  participle: "Participle",
  pertainym: "Pertainym",
  secondary_aspect_ip: "Secondary aspect IP",
  secondary_aspect_pi: "Secondary aspect PI",
  similar: "Similar",
  simple_aspect_ip: "Simple aspect IP",
  simple_aspect_pi: "Simple aspect PI",
  young: "Young",
  domain_member_region: "Domain member region",
  domain_member_topic: "Domain member topic",
};

export const SynsetRelationRelType: Record<string, string> = {
  agent: "Agent",
  also: "See also",
  anto_converse: "Converse antonym",
  anto_gradable: "Gradable antonym",
  anto_simple: "Simple antonym",
  antonym: "Antonym",
  attribute: "Attribute",
  augmentative: "Augmentative",
  be_in_state: "Be in state",
  cause: "Cause",
  causes: "Causes",
  classified_by: "Classified by",
  classifies: "Classifies",
  co_agent_instrument: "Co-agent instrument",
  co_agent_patient: "Co-agent patient",
  co_agent_result: "Co-agent result",
  co_instrument_agent: "Co-instrument agent",
  co_instrument_patient: "Co-instrument patient",
  co_instrument_result: "Co-instrument result",
  co_patient_agent: "Co-patient agent",
  co_patient_instrument: "Co-patient instrument",
  co_result_agent: "Co-result agent",
  co_result_instrument: "Co-result instrument",
  co_role: "Co-role",
  diminutive: "Diminutive",
  direction: "Direction",
  domain_member_region: "Domain member region",
  domain_member_topic: "Domain member topic",
  domain_region: "Domain region",
  domain_topic: "Domain topic",
  entail: "Entail",
  entails: "Entails",
  eq_synonym: "Equivalent synonym",
  exemplifies: "Exemplifies",
  feminine: "Feminine",
  has_augmentative: "Has augmentative",
  has_diminutive: "Has diminutive",
  has_domain_region: "Has domain region",
  has_domain_topic: "Has domain topic",
  has_feminine: "Has feminine",
  has_masculine: "Has masculine",
  has_young: "Has young",
  holo_location: "Holonym location",
  holo_member: "Member holonym",
  holo_part: "Part holonym",
  holo_portion: "Portion holonym",
  holo_substance: "Substance holonym",
  holonym: "Holonym",
  hypernym: "Hypernym",
  hyponym: "Hyponym",
  in_manner: "In manner",
  instance_hypernym: "Instance hypernym",
  instance_hyponym: "Instance hyponym",
  instrument: "Instrument",
  involved: "Involved",
  involved_agent: "Involved agent",
  involved_direction: "Involved direction",
  involved_instrument: "Involved instrument",
  involved_location: "Involved location",
  involved_patient: "Involved patient",
  involved_result: "Involved result",
  involved_source_direction: "Involved source direction",
  involved_target_direction: "Involved target direction",
  ir_synonym: "IR synonym",
  is_caused_by: "Is caused by",
  is_entailed_by: "Is entailed by",
  is_exemplified_by: "Is exemplified by",
  is_subevent_of: "Is subevent of",
  location: "Location",
  manner_of: "Manner of",
  masculine: "Masculine",
  member_holonym: "Member holonym",
  member_meronym: "Member meronym",
  mero_location: "Meronym location",
  mero_member: "Member meronym",
  mero_part: "Part meronym",
  mero_portion: "Portion meronym",
  mero_substance: "Substance meronym",
  meronym: "Meronym",
  other: "Other",
  part_holonym: "Part holonym",
  part_meronym: "Part meronym",
  patient: "Patient",
  restricted_by: "Restricted by",
  restricts: "Restricts",
  result: "Result",
  role: "Role",
  similar: "Similar",
  source_direction: "Source direction",
  state_of: "State of",
  subevent: "Subevent",
  substance_holonym: "Substance holonym",
  substance_meronym: "Substance meronym",
  target_direction: "Target direction",
  young: "Young",
};

export const AdjPosition: Record<string, string> = {
  a: "Attributive",
  ip: "Immediate postnominal",
  p: "Predicative",
};
